import React, { useState } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import axios from 'axios';
import { Lightning } from '@phosphor-icons/react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Login = ({ onLoginSuccess }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('client');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
      } else {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        
        // Register user in backend
        await axios.post(`${API}/auth/register`, {
          email: user.email,
          name: name,
          role: role,
          firebase_uid: user.uid
        });
      }
      
      if (onLoginSuccess) onLoginSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1744113511604-235e7010981f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBpbmR1c3RyaWFsfGVufDB8fHx8MTc3NTc0OTY5NXww&ixlib=rb-4.1.0&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'brightness(0.3)'
        }}
      />

      {/* Login Card */}
      <div className="relative z-10 w-full max-w-md p-8 bg-[#121212] border border-[#27272A] rounded-sm shadow-2xl">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img 
            src="/toolserv-logo.png" 
            alt="Toolserv"
            className="h-12"
          />
        </div>

        <div className="flex items-center justify-center mb-6">
          <Lightning size={32} weight="fill" className="text-[#FFB800] mr-2" />
          <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Barlow Condensed' }}>
            {isLogin ? 'Login' : 'Criar Conta'}
          </h2>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-900/20 border border-red-500 rounded-sm text-red-500 text-sm" data-testid="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} data-testid="login-form">
          {!isLogin && (
            <div className="mb-4">
              <label className="block text-zinc-400 text-sm mb-2">Nome</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="w-full px-4 py-2 bg-[#050505] border border-[#27272A] rounded-sm text-white focus:border-[#FFB800] focus:ring-1 focus:ring-[#FFB800] outline-none"
                required={!isLogin}
                data-testid="name-input"
              />
            </div>
          )}

          <div className="mb-4">
            <label className="block text-zinc-400 text-sm mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 bg-[#050505] border border-[#27272A] rounded-sm text-white focus:border-[#FFB800] focus:ring-1 focus:ring-[#FFB800] outline-none"
              required
              data-testid="email-input"
            />
          </div>

          <div className="mb-4">
            <label className="block text-zinc-400 text-sm mb-2">Senha</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 bg-[#050505] border border-[#27272A] rounded-sm text-white focus:border-[#FFB800] focus:ring-1 focus:ring-[#FFB800] outline-none"
              required
              data-testid="password-input"
            />
          </div>

          {!isLogin && (
            <div className="mb-4">
              <label className="block text-zinc-400 text-sm mb-2">Tipo de Conta</label>
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="w-full px-4 py-2 bg-[#050505] border border-[#27272A] rounded-sm text-white focus:border-[#FFB800] focus:ring-1 focus:ring-[#FFB800] outline-none"
                data-testid="role-select"
              >
                <option value="client">Cliente</option>
                <option value="prestador">Prestador</option>
                <option value="admin">Administrador</option>
              </select>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-[#FFB800] text-black font-semibold rounded-sm hover:bg-[#E6A600] transition-colors disabled:opacity-50"
            data-testid="submit-button"
          >
            {loading ? 'Processando...' : (isLogin ? 'Entrar' : 'Criar Conta')}
          </button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={() => setIsLogin(!isLogin)}
            className="text-[#FFB800] hover:text-[#E6A600] transition-colors text-sm"
            data-testid="toggle-mode-button"
          >
            {isLogin ? 'Não tem uma conta? Criar conta' : 'Já tem uma conta? Fazer login'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
